import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import TableWithSorter from '../../../components/Common/TableWithSorter';

const CommunityResourceTable = ({
  data,
  communities,
  loading,
  totalData,
  onPaginationChange
}) => {
  const columns = [
    {
      title: 'Topic index',
      dataIndex: 'topicIndex',
      key: 'eventId'
    },
    {
      title: 'Sub index',
      dataIndex: 'subIndex',
      key: 'subIndex'
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <a href={`/community/resource/${record?._id}`}>{text}</a>
      )
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => <div style={{ width: 300 }}>{text}</div>
    },
    {
      title: 'Topic',
      dataIndex: 'topic',
      key: 'topic'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Link',
      dataIndex: 'link',
      key: 'link',
      render: (text, record) => <a href={text}>{text}</a>
    },
    {
      title: 'Communities',
      dataIndex: 'communityObjectId',
      key: 'communityObjectId',
      render: (text, record) => {
        const community =
          communities[communities?.findIndex((c) => c._id === text)];
        return (
          <div>
            <div>
              <Link to={`/community/${community?._id}`}>
                {community?.code}
              </Link>
            </div>
          </div>
        );
      }
    }
  ];

  return (
    <div className="community-events-table">
      <TableWithSorter
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        dataSource={data}
        loading={loading}
        columns={columns}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
          total: totalData
        }}
        onChange={onPaginationChange}
      />
      )
    </div>
  );
};

export default CommunityResourceTable;
